import type { ReactElement, SVGProps } from "react";

export function TinyXIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 8 8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      {...props}
    >
      <path d="M2 2l4 4M6 2l-4 4" />
    </svg>
  );
}
